module.exports = __webpack_public_path__ + "media/images/spree/frontend/content/sizing/step3-6de70a9aac6fb4539fe1408c6fc8c821.jpg";